import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getHealthPlanStart,
  getHealthPlanSuccess,
  getHealthPlanFailure,
} from "../reducers/getHealthPlanReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";
import moment from "moment";

export const getHealthPlan = createAsyncThunk(
  "getHealthPlan",
  async ({ product_id, DOB }, thunkAPI) => {
    try {
      thunkAPI.dispatch(getHealthPlanStart());
      const token = Cookies.get("token");
      const dateOfBirth = moment(DOB).format("DD-MMM-YYYY");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Health/GetPlan?product_id=${product_id}&DOB=${dateOfBirth}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getHealthPlanSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getHealthPlanFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
        await thunkAPI.dispatch(getHealthPlan());
      }
      throw error;
    }
  }
);
